module.exports = __webpack_public_path__ + "static/media/JUBLFOOD.1de560f4.txt";